import React, { useEffect, useState } from "react"
import Arrow from "./img/arrow.png"

function Main() {
	const [data, setData] = useState([])
	useEffect(() => {
		fetch(
			"https://sheet.best/api/sheets/48f24a76-4650-45dc-a294-27c9e9b26639?_raw=1",
		)
			.then((response) => response.json())
			.then((data) => {
				console.log(data)
				setData(data)
			})
			.catch((error) => {
				console.error(error)
			})
	}, [])
	return (
		<div className="main-wrapper">
			<div className="outer-wrapper">
				<div className="wrapper">
					<div className="main-slide ">
						<p>Strategy, branding &</p>
						<p>experiences for the digital</p>
						<p>era.</p>
						<div>
							<img src={Arrow} alt="" />
						</div>
					</div>

					{data.map((item) => {
						return (
							<div
								className="slide"
								onClick={() => {
									window.location.assign(`/blog/${item.url}`)
								}}>
								<div
									className="slide-in"
									style={{ backgroundImage: `url(${item.image})` }}>
									<div className="slide-in-title">
										<p>
											<code>{item.author} </code>
										</p>
										<h2>{item.title} </h2>
									</div>
								</div>
							</div>
						)
					})}
				</div>
			</div>
		</div>
	)
}

export default Main
